import { useEffect, useMemo, useRef } from 'react';
import debounce from 'hs-lodash/debounce';

// Keeps a ref to the latest callback so the debounced function always
// calls the current version, even if the caller doesn't wrap it in useCallback.
export function useDebouncedCallback(callback, delayMs) {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  });
  return useMemo(() => debounce((...args) => callbackRef.current(...args), delayMs), [delayMs]);
}